export const createAtlasPaletteOptions = (tokens) => {
    const { core: { color: { legacy: { black, white }, brand, }, }, semantic: { color: { status: { error, success, warning, new: newStatus, notification }, destructive, text, action, background, ui, }, }, } = tokens;
    return {
        common: {
            black: black.value,
            white: white.value,
        },
        primary: {
            main: brand.value,
            contrastText: white.value,
        },
        // No Secondary color in Atlas design system
        // secondary: {
        //   contrastText: coreColor.legacy.white.value,
        // },
        error: {
            main: error.value,
            contrastText: text.inverse.value,
        },
        destructive: {
            main: destructive.default.value,
            dark: destructive.hover.value,
            contrastText: text.inverse.value,
        },
        success: {
            main: success.value,
        },
        warning: {
            main: warning.value,
        },
        new: {
            main: newStatus.value,
            contrastText: text.inverse.value,
        },
        disabled: {
            main: text.disabled.value,
            contrastText: text.inverse.value,
        },
        info: {
            main: notification.value,
        },
        // grey
        // info
        text: {
            primary: text.body.value,
            secondary: text.muted.value,
            disabled: text.disabled.value,
        },
        divider: ui.divider.value,
        background: {
            paper: background.container.value,
            container: background.container.value,
            base: background.base.value,
            disabled: background.disabled.value,
            top: background.top.value,
            statusBar: background.statusBar.value,
        },
        action: {
            active: action.active.value,
            hover: action.hover.value,
            //  select
            disabled: action.disabled.value,
            focus: "transparent",
        },
    };
};
//# sourceMappingURL=createAtlasPaletteOptions.js.map